import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

import { InputStyled } from '../../Perfil/Editar/styles.js';
import { PoliticasDeSenha } from '../../../../components/PoliticasDeSenha/index.js';

export function Credencial({ id, confirmPassword, deslogar }) {
  const [senha, setSenha] = useState('');
  return (
    <>
      {confirmPassword && (
        <Form.Item
          tooltip="Digite sua senha atual."
          name="senhaAnterior"
          label="Senha anterior"
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            color: '#707070',
          }}
        >
          <InputStyled.Password size="large" autoComplete="off" />
        </Form.Item>
      )}
      <Form.Item
        tooltip="Digite sua nova senha."
        name="senha"
        label="Nova Senha"
        hasFeedback
        style={{
          fontWeight: 'bold',
          fontSize: '14px',
          lineHeight: '16px',
          color: '#707070',
        }}
      >
        <InputStyled.Password
          size="large"
          autoComplete="off"
          onChange={e => setSenha(e.currentTarget.value)}
        />
      </Form.Item>
      <PoliticasDeSenha senha={senha} />
      <Form.Item
        tooltip="Confirme sua nova senha."
        name="confirmarSenha"
        label="Confirmar Senha"
        dependencies={['password']}
        hasFeedback
        rules={[
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('senha') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('As senhas não conferem'));
            },
          }),
        ]}
        style={{
          fontWeight: 'bold',
          fontSize: '14px',
          lineHeight: '16px',
          color: '#707070',
        }}
      >
        <InputStyled.Password size="large" autoComplete="off" />
      </Form.Item>
    </>
  );
}

Credencial.propTypes = {
  id: PropTypes.string,
  confirmPassword: PropTypes.bool,
  deslogar: PropTypes.bool,
};

Credencial.defaultProps = {
  id: null,
  confirmPassword: false,
  deslogar: false,
};
